// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uRCoN","col":"styles_col__1b75y"};